<template>
  <div v-if="loadingContents.length > 1">
    <div
      v-for="item in loadingContents"
      :key="item"
      class="flex-container-line w-100 px-3 py-2 border-bottom hover-highlight pointer">
      <skeleton-loader-vue
        type="circle"
        :width="44"
        :height="44"></skeleton-loader-vue>
      <div>
        <skeleton-loader-vue
          class="my-3"
          height="16"></skeleton-loader-vue>
        <skeleton-loader-vue
          class="my-3"
          height="16"></skeleton-loader-vue>
      </div>
    </div>
  </div>
  <div
    v-else
    class="flex-container-line px-3 border-bottom load-more">
    <skeleton-loader-vue
      type="circle"
      :width="44"
      :height="44"></skeleton-loader-vue>
    <div>
      <skeleton-loader-vue
        class="my-3"
        height="16"></skeleton-loader-vue>
      <skeleton-loader-vue
        class="my-3"
        height="16"></skeleton-loader-vue>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["num"],
  data() {
    return {
      loadingCount: 7,
    };
  },
  mounted() {
    this.loadingCount = this.num || this.loadingCount;
  },
  computed: {
    loadingContents() {
      if (this.loadingCount <= 0) {
        return [];
      }
      return Array.from({ length: this.loadingCount }, (item, index) => index);
    },
  },
};
</script>

<style >
.load-more {
  margin-top: -30px;
}
.loader {
  cursor: default !important;
}
</style>